import { FuseNavigationModelInterface } from '../core/components/navigation/navigation.model';

export class FuseNavigationModel implements FuseNavigationModelInterface
{
    public model: any[];

    constructor()
    {
        this.model = [
            {
                'id'      : 'surgeries',
                'title'   : 'Surgeries',
                'translate': 'NAV.SURGERIES',
                'type'    : 'group',
                'children': [
                    {
                        'id'       : 'newsurgery',
                        'title'    : 'New Surgery',
                        'translate': 'NAV.NEWSURGERIES',
                        'type'     : 'item',
                        'icon'     : 'assessment',
                        'url'      : '/apps/scrumboard'
                    },
                    {
                        'id'       : 'continuesurgery',
                        'title'    : 'Continue Surgery',
                        'translate': 'NAV.CONTINUESURGERIES',
                        'type'     : 'item',
                        'icon'     : 'assessment',
                        'url'      : '/apps/scrumboard'
                    },
                    {
                        'id'       : 'watchsurgery',
                        'title'    : 'Watch Surgery',
                        'translate': 'NAV.WATCHSURGERIES',
                        'type'     : 'item',
                        'icon'     : 'assessment',
                        'url'      : '/apps/scrumboard'
                    }
                ]  
            },
            {
            'id'      : 'console',
            'title'   : 'Console',
            'translate': 'NAV.CONSOLE',
            'type'    : 'group',
            'children': []
            }
        ];
    }
}



// WEBPACK FOOTER //
// C:/Users/Marion Surgical/Desktop/Sean/marion-surgical-master/src/app/navigation/navigation.model.ts